<template>
  <form>
    <VTextField
      v-model="data.url"
      :label="$t('forms.labels.url')"
      :rules="{ required: true, min: 1, max: 200 }"
      @input="updateData"
    />
    <VTextField
      v-model="data.title"
      :label="$t('forms.labels.title')"
      :rules="{ required: true, min: 1, max: 200 }"
      @input="updateData"
    />
    <VTextField
      v-model="data.duration"
      :label="$t('forms.labels.duration')"
      placeholder="HH:MM:SS"
      @input="updateData"
    />
    <v-row>
      <v-col cols="6">
        <VSelect
          v-model="data.category"
          :label="$t('forms.labels.category')"
          :items="videoCategories"
          :required="true"
          itemValue="key"
          itemText="name"
          @input="updateData"
        />
      </v-col>
      <v-col cols="6">
        <VSelect
          v-model="data.lang"
          itemValue="key"
          itemText="name"
          :required="true"
          :label="$t('forms.labels.lang')"
          :items="langs"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </form>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import { LOCALES } from '@/locales/i18n';
import { mapGetters } from 'vuex';

export default {
    components: {
        VTextField,
        VSelect,
    },
    props: {
        payload: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            data: {
                url: '',
                title: '',
                duration: '',
                category: '',
                lang: '',
                id: '',
            },
            langs: [],
            videoCategories: [],
        };
    },
    computed: {
        ...mapGetters([
            'lang',
            'userLang',
        ]),
    },
    mounted() {
        if (this.payload) {
            this.data.url = this.payload.url;
            this.data.title = this.payload.title;
            this.data.id = this.payload.id;
            this.data.duration = this.payload.duration || '';
            LOCALES.forEach(lang => {
                if (this.lang === lang) {
                    this.data.lang = lang;
                }
            });
            this.$emit('sendData', this.data);
        }
        this.getVideoCategories();
        this.getLangs();
    },
    methods: {
        async getVideoCategories() {
            const { data } = await this.$rq.getVideoCategories();
            data.forEach(videoCategory => {
                if (this.payload && this.payload.category === videoCategory.name[this.userLang]) {
                    this.data.category = videoCategory.id;
                }
            });
            this.videoCategories = data.map(videoCategory => ({ name: videoCategory.name[this.userLang], key: videoCategory.id }));
        },
        getLangs() {
            this.langs = LOCALES.map(lang => ({
                name: this.$t(`langs.${lang}`),
                key: lang,
            }));
        },
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
